enum SigningMethodType {
  EMAIL = 'email',
  KAKAO = 'kakao',
  IN_PERSON = 'IN_PERSON',
}

export default SigningMethodType;
